import React from 'react';
import { CONFLICT_TYPE } from '../../main/barbers/scheduleConflictsHelpers';

const getDayConflictTitle = (dayConflicts, isDayOnConflicts) => {
  if (!dayConflicts || !dayConflicts.length) {
    return '';
  }

  const hasBarberSchedulesConflicts =
    dayConflicts.some(conflict => conflict.conflictType === CONFLICT_TYPE.BARBER_WORKS_AT_ANOTHER_SHOP);

  if (hasBarberSchedulesConflicts) {
    return isDayOnConflicts ? 'Working partially' : 'Time conflict';
  }

  const hasShopScheduleConflict =
    dayConflicts.some(conflict => conflict.conflictType === CONFLICT_TYPE.SHOP_IS_ROUTINELY_CLOSED);
  if (hasShopScheduleConflict) {
    return 'Shop closed';
  }

  // in theory this shouldn't happen, it's just in case fallback
  return 'Time conflict';
};

export const getScheduleDayConflictMessage = (dayConflicts) => {
  const barberSchedulesConflicts =
    dayConflicts.conflicts.filter(conflict => conflict.conflictType === CONFLICT_TYPE.BARBER_WORKS_AT_ANOTHER_SHOP);

  if (barberSchedulesConflicts.length) {
    const suffix = barberSchedulesConflicts.length > 1 ?
      `${` and ${barberSchedulesConflicts.length - 1} other location(s)`}` :
      '';

    const firstConflictedShopName = barberSchedulesConflicts[0].shopName;

    return `There is a time conflict with this time on ${firstConflictedShopName}${suffix}`;
  }

  const hasShopScheduleConflict =
    dayConflicts.conflicts.some(conflict => conflict.conflictType === CONFLICT_TYPE.SHOP_IS_ROUTINELY_CLOSED);
  if (hasShopScheduleConflict) {
    return 'Please note that shop is routinely closed on this day. Work day can still be added';
  }

  // in theory this shouldn't happen, it's just in case fallback
  return 'There is a time conflict with this time.';
};

export const getScheduleDayConflictTooltip = dayConflicts => ({
  title: getDayConflictTitle(dayConflicts.conflicts, false),
  text: getScheduleDayConflictMessage(dayConflicts),
});

export const getDayOnConflictWithBarberScheduleMessage = barberSchedulesConflict =>
  // eslint-disable-next-line max-len
  `You're working from ${barberSchedulesConflict.startTime} to ${barberSchedulesConflict.endTime} at ${barberSchedulesConflict.shopName}.`;

export const getDayOnConflictMessages = (dayOnConflicts) => {
  if (!dayOnConflicts || !dayOnConflicts.length) {
    return [''];
  }

  const barberSchedulesConflicts =
    dayOnConflicts.filter(conflict => conflict.conflictType === CONFLICT_TYPE.BARBER_WORKS_AT_ANOTHER_SHOP);

  if (barberSchedulesConflicts.length) {
    const conflictsMessageItems = [];

    barberSchedulesConflicts.forEach((barberSchedulesConflict) => {
      conflictsMessageItems.push(getDayOnConflictWithBarberScheduleMessage(barberSchedulesConflict));
    });

    conflictsMessageItems.push('You can select other hours to take a day on.');

    return conflictsMessageItems;
  }

  const shopScheduleConflict =
    dayOnConflicts.find(conflict => conflict.conflictType === CONFLICT_TYPE.SHOP_IS_ROUTINELY_CLOSED);
  if (shopScheduleConflict) {
    return ['Please note that shop is routinely closed on this day. Days On can still be added.'];
  }

  // in theory this shouldn't happen, it's just in case fallback
  return ['You\'re working at another shop. You can select other hours to take a day on.'];
};

export const getDayOnConflictTooltip = (dayOnConflicts) => {
  if (!dayOnConflicts || !dayOnConflicts.length) {
    return {};
  }

  return {
    title: getDayConflictTitle(dayOnConflicts, true),
    text: (
      <span>
        { getDayOnConflictMessages(dayOnConflicts).map(messageItem => (
          <React.Fragment>
            {messageItem}
            <br />
          </React.Fragment>
        ))}
      </span>
    ),
  };
};
